import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PersonStores, usePeopleTypesStore } from '@/store';
import { LocationFormInterface } from '@/types';
import { useToast } from 'primevue/usetoast';
import { PERMISSIONS } from '@/enum';
import { can } from '@/composables';
import { UserLocationForm } from '@/components/Forms';

/**
 * set up the toast
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'UserLocation',
  setup(__props) {

const toast = useToast();

/**
 * All of the state references including the convertion of the
 * profile location state object into a ref.
 */
const profileStore = PersonStores.useUserProfileStore();

const PEOPLE_TYPES = usePeopleTypesStore().PEOPLE_TYPES;

/**
 * Handle save event emitted by the child component
 * in order to reset the user location data.
 */
const onSave = async (data: LocationFormInterface) => {
  const response = await profileStore.updateLocationInfo(data);
  if (response === 200) {
    doToast();
  } else {
    doToast(true);
  }
};

/**
 * Display the toast message.
 */
const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'there was an error' : 'User Location information has been saved',
    life: 3000,
  });
};

const canUpdateLocation = () => {
  const personType: string = profileStore.person?.people_type?.acronym as string;
  let permissionString = 'PEOPLE_LOCATION_UPDATE';
  let str: keyof typeof PERMISSIONS;
  switch (personType) {
    case PEOPLE_TYPES.SUPPORT_ADMIN: {
      permissionString += '_SUPPORT_ADMIN';
      break;
    }
    case PEOPLE_TYPES.SCHOOL_ADMIN: {
      permissionString += '_SCHOOL_ADMIN';
      break;
    }
    case PEOPLE_TYPES.SUPER_ADMIN: {
      permissionString += '_SUPER_ADMIN';
      break;
    }
  }
  str = permissionString as keyof typeof PERMISSIONS;
  return can([PERMISSIONS[str]]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UserLocationForm), {
    "permission-to-edit": canUpdateLocation(),
    data: _unref(profileStore).location,
    loading: (_unref(profileStore).loading as boolean),
    onSave: onSave
  }, null, 8, ["permission-to-edit", "data", "loading"]))
}
}

})